import { useCallback, useState } from 'react'

import { type TermsMethodsKindEnum } from '@webapp/modules/purchasing/entities/enums/TermsMethodsKindEnum'
import { useQueryTermsAndMethods } from '@webapp/modules/purchasing/features/list-terms-and-methods/models'

const PAGE_SIZE = 10

export interface UseTermsMethodsListPresenterParams {
  kind: TermsMethodsKindEnum
}

export const useTermsMethodsListPresenter = ({
  kind,
}: UseTermsMethodsListPresenterParams) => {
  const [page, setPage] = useState(1)

  const { items, pagination, isLoading, isFetching } = useQueryTermsAndMethods(
    kind,
    {
      page,
      pageSize: PAGE_SIZE,
    }
  )

  const onPrevPage = useCallback(() => {
    setPage((currentPage) => Math.max(1, currentPage - 1))
  }, [])

  const onNextPage = useCallback(() => {
    setPage((currentPage) =>
      pagination.numPages > 0
        ? Math.min(pagination.numPages, currentPage + 1)
        : currentPage
    )
  }, [pagination.numPages])

  return {
    data: {
      items,
      numPages: pagination.numPages,
    },
    states: {
      page,
      isLoading,
      isFetching,
    },
    methods: {
      onPrevPage,
      onNextPage,
    },
  }
}
